import { useCallback, useEffect, useState } from 'react';
import { Button, Link } from '@mui/material';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';
import { VendorTipService } from '../../services/VendorTipService';
import { getReferenceName } from '../../utils/walletTransactionReference';

const vendorTipService = new VendorTipService();

interface InputProps {
    customerId: number;
}

const COLUMNS: CommonListColumn[] = [
    { label: 'Id', field: 'id' },
    { label: 'Amount', field: 'amount' },
    {
        label: 'Customer Id',
        render: (row) => (
            <Link href={`/#/Customers/${row?.customerId}/show`}>{row?.customerId}</Link>
        ),
    },
    {
        label: 'Cook Id',
        render: (row) => (
            <Link href={`/#/Cooks/${row?.cookId}/show`}>{row?.cookId}</Link>
        ),
    },
    {
        label: 'Reference Id',
        render: (row) => (
            <Link
                href={`/#/${getReferenceName(row?.referenceModelName)}/${row?.referenceId}/show`}
            >
                {row?.referenceId}
            </Link>
        ),
    },
    {
        label: 'Reference Model Name',
        render: (row) => row?.referenceModelName || '---',
    },
    {
        label: 'Action',
        stopRowClick: true,
        render: (row) => (
            <Link href={`/#/VendorTip/${row?.id}/show`}>
                <Button variant="contained" color="primary" size="small">Show</Button>
            </Link>
        ),
    },
];

function VendorTipListForCustomer({ customerId }: InputProps) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState<any[]>([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    const refreshData = useCallback(() => {
        setLoading(true);
        vendorTipService
            .getAllVendorTipsForCustomer(customerId, rowsPerPage, rowsPerPage * page, {
                order: 'DESC',
                field: 'createdAt',
            })
            .then((res: any) => {
                setData(res?.data ?? []);
                setTotal(res?.count ?? 0);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [customerId, page, rowsPerPage]);

    useEffect(() => {
        refreshData();
    }, [refreshData]);

    return (
        <CommonListTable
            columns={COLUMNS}
            data={data}
            loading={loading}
            page={page}
            rowsPerPage={rowsPerPage}
            total={total}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
            emptyText="No Tip Found"
        />
    );
}

export default VendorTipListForCustomer;
